import React from 'react';
import styles from './APIDocumentation.module.css';

const APIDocumentation: React.FC = () => {
    return (
        <div className={styles.container}>
            <h2>API Documentation Page</h2>
            <p>API documentation content will go here.</p>
        </div>
    );
};

export default APIDocumentation; 